import { TableRowData } from 'types';
import joinPath from './joinPath';

export default function getWorkZoneLink(server: string, row: TableRowData) {
	return joinPath(server, 'app/client/#/Records', String(row.id));
}
